<template>
    <feather-icon :icon="icon" svgClasses="h-4 w-4" />
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: 'CellRendererVerified',
  computed: {
    icon() {
      let value = this.params.value;

      if (this.isNumeric(this.params.value)) {
        value = parseInt(this.params.value);
      }

      return value ? 'CheckCircleIcon' : ''
    },
  },
  methods: {
    isNumeric(str) {
      if (typeof str != "string") {
        return false
      }

      return !isNaN(str) && !isNaN(parseFloat(str))
    }
  },
})
</script>
